import { FC, useState } from "react";

import { Box, Typography } from "@mui/material";

import { BreadCrumbsArchive } from "@/components/Application/BreadCrumbsDesign";
import { Translate } from "@/components/Application/Translate";
import ArchiveProjectsChart from "@/components/Archive/ArchiveProjectsChart";
import HistoryContainer from "@/components/Archive/Components/History/Container";

import DashboardGrid from "@/helpers/components/Dashboard/DashboardGrid";

import { useFetchArchivedProcedure } from "@/service/ArchiveQueries";

export const ArchiveProcedure: FC = () => {
	const [searchActive, setSearchActive] = useState(true);
	const [startDate, setStartDate] = useState<Date>();
	const [endDate, setEndDate] = useState<Date>();
	const [selectedUser, setSelectedUser] = useState(0);

	const toggleSearch = (value: boolean) => {
		setSearchActive(value);
		setStartDate(undefined);
		setEndDate(undefined);
		setSelectedUser(0);
	};

	const { data: archivedProcedure } = useFetchArchivedProcedure();

	return (
		<>
			<BreadCrumbsArchive />
			<DashboardGrid
				dashboardHeader={archivedProcedure?.Name}
				dashboardSubheader={archivedProcedure?.Description}
			>
				{/* <Box sx={{ p: 2, gridColumn: { xs: "span 12", md: "span 6" } }}>
						<ArchiveProcedureInfo
							startDate={startDate}
							endDate={endDate}
							selectedUser={selectedUser}
						/>
						</Box> */}
				<Box
					sx={{
						gridColumn: { xs: "span 7" },
						gridRow: { xs: "1 / 2" },
						display: "grid",
						gridTemplateColumns: "repeat(12, 1fr)",
						gridTemplateRows: ".5fr 1fr",
						rowGap: "1rem",
						columnGap: "1rem",
					}}
				>
					<Typography
						variant="h4"
						component="h1"
						sx={{ fontWeight: "550", gridColumn: "span 12" }}
					>
						<Translate String="Archive.Statistics">Stats</Translate>
					</Typography>
					<Box sx={{ gridColumn: {xs: "span 12"} }}>
						<ArchiveProjectsChart />
					</Box>
				</Box>
				<Box sx={{ gridColumn: { xs: "8 / span 5" }, gridRow: { xs: "1" } }}>
					<HistoryContainer initialRowsPerPage={10} />
				</Box>
			</DashboardGrid>
		</>
	);
};
